// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__ymVch","containerCard":"Projects_containerCard__QzLUq"};